@if (profileField$ | async; as profileField) {
  <sh-form-tag-list
    [id]="profileField.FieldDefinition.FlatKey"
    [control]="control$ | async"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [helpText]="profileField.Description"
    [placeholder]=""
    [duplicateErrorMsg]=""
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [canBeIndeterminate]="canBeIndeterminate"
    [indeterminateMsg]="'general.only-matching-values-shown' | translate"
    [caseSensitive]="false"
    [autocompleteFct]="autocompleteFunction"
    [title]="disabledMessageKey | translate"
    (duplicateValues)="receiveDuplicatesEmitted($event)"
    >
    <ng-content></ng-content>
  </sh-form-tag-list>
}

@if (visibleDuplicates.length > 0) {
  <div class="sh-form-group">
    <label for="input-field-5" class="sh-form-group__label">
      <em class="sh-form-group__label__em"> </em>
      {{ "form.keywords.duplicates" | translate }}
    </label>
    <med-tag-suggestions [tags]="visibleDuplicates" (tagAccepted)="duplicateAccepted($event)" (tagDeclined)="duplicateDeclined($event)"></med-tag-suggestions>
  </div>
}

@if (control$ | async; as control) {
  @if (suggestionsEnabled && !control.disabled) {
    <div class="sh-form-group">
      <label for="input-field-5" class="sh-form-group__label">
        <em class="sh-form-group__label__em"> </em>
        {{ "form.suggestions.keyword-ai.ai-suggestions" | translate }}
      </label>
      <med-tag-suggestions
        [tags]="visibleSuggestions"
        (tagAccepted)="tagAccepted($event)"
        (tagDeclined)="tagDeclined($event)"
        [noTagsMessage]="'form.suggestions.keyword-ai.no-suggestions' | translate"
      ></med-tag-suggestions>
    </div>
  }
}
